// extracted by mini-css-extract-plugin
export default {"compareCard":"SGtdlOkdgl","topBar":"fWU2tgAvZ0","removeButton":"Mf_TxprFMD","contentWrapper":"fZewaMp8QW","previewImageContainer":"FIQXK7STbb","previewImage":"nwlR4Hs1gh"};